import axios from 'axios';
//GET 用户组列表 http://dev.ucenter.com/api.php?s=group/index
//GET 用户组增加规则页(访问授权) http://dev.ucenter.com/api.php?s=group/rule&group_id=1
//正式服接口
//let base = 'https://admin-dist-api.y7y.net/';

let base = 'https://beta-dist-api.y7y.net/';

//beta服接口
//let base2='https://admin-sdk-api.y7y.net/'
let base2 = 'https://beta-sdk-api.y7y.net/';

//登录
export const requestLogin = params => { return axios.post(`${base}user/login`, params).then(res => res.data); };
//修改密码
export const updatePwd = (p,token) => { return axios.put(`${base}user/password`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }}).then(res => res.data); };
//获取用户列表
export const getUserList = (token)=> { return axios.get(`${base}user/index`,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };
//禁用删除用户
export const forbidUser = (p,token)=> { return axios.put(`${base}user/index`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };
//新增用户
export const addUser = (p,token)=> { return axios.post(`${base}user/index`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };
//获取用户所在列表
export const getGroupList = (uid,token)=> { return axios.get(`${base}user/group&uid=${uid}`,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };
//改变用户所在组
export const setUserGroup = (p,token)=> { return axios.put(`${base}user/group`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };


//获取用户组列表
export const getGroups = (token)=> { return axios.get(`${base}group/index`,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };
//新增用户组列表
export const addGroups = (p,token)=> { return axios.post(`${base}group/index`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };
//编辑用户组名称描述
export const editGroups = (p,token)=> { return axios.put(`${base}group/index`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };
//获取访问授权页列表
export const getRules = (id,token)=> { return axios.get(`${base}group/rule&group_id=${id}`,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };


//获取规则列表
export const getRuleList = (pid,token)=> { return axios.get(`${base}rule/index&pid=${pid}`,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };
//编辑规则列表
export const editRule = (p,token)=> { return axios.put(`${base}rule/index`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };
//新增规则菜单
export const addRule = (p,token)=> { return axios.post(`${base}rule/index`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };

//编辑规则菜单
export const changeRule = (p,token)=> { return axios.put(`${base}rule/index`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };

//批量排序规则菜单
export const changeSort = (p,token)=> { return axios.post(`${base}rule/sort`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };

export const getUserListPage = params => { return axios.get(`${base}/user/listpage`, { params: params }); };

export const removeUser = params => { return axios.get(`${base}/user/remove`, { params: params }); };

export const batchRemoveUser = params => { return axios.get(`${base}/user/batchremove`, { params: params }); };

export const editUser = params => { return axios.get(`${base}/user/edit`, { params: params }); };

// export const addUser = params => { return axios.get(`${base}/user/add`, { params: params }); };
//修改密码
export const scpwd = (p,token) => { return axios.put(`${base}user/password`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//分配权限到用户组
export const postDistribution = (p,token)=> { return axios.post(`${base}rule/group`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };

//获取产品授权列表
export const getAppList = (token)=> { return axios.get(`${base}/user/app`,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };

export const setUserApp =(p,token)=> { return axios.post(`${base}/rule/app`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };

//获取用户
export const getUserApp = (uid,token)=> { return axios.get(`${base}//rule/app&uid=${uid}`,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };

//用户配置 
export const sconfig = (token) => { return axios.get(`${base}setting/index`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//账号管理 - 列表
export const getPlist = (p,token) => { return axios.get(`${base}/issuedAppBase/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//账号管理 - 增加
export const getPAdd = (p,token) => { return axios.post(`${base}issuedAppBase/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//账号管理 - 编辑get
export const getPGetEdit = (p,token) => { return axios.get(`${base}issuedAppBase/edit?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//账号管理 - 编辑post
export const getPEdit = (p,token) => { return axios.post(`${base}issuedAppBase/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//分成公司筛选列表
export const getCPCompanyList  =(p,token) => { return axios.get(`${base}cpCompany/select?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//账号管理 - 状态
export const getPStatus = (p,token) => { return axios.post(`${base}issuedAppBase/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//cp公司列表
export const getCPCompanyList2 = (p,token) => { return axios.get(`${base2}cpCompany/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//增加cp公司
export const CPcompanyAdd = (p,token) => { return axios.post(`${base2}cpCompany/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//编辑cp公司
export const CPcompanyEdit = (p,token) => { return axios.post(`${base2}cpCompany/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//选择cp公司
export const selectCPCompany = (p,token) => { return axios.get(`${base2}cpCompany/select?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//cp公司状态
export const CPcompanyStatus = (p,token) => { return axios.post(`${base2}cpCompany/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


// WEBPACK FOOTER //
// ./src/api/api.js